import { ChangeDetectionStrategy, ChangeDetectorRef, Component, inject, Inject, OnInit, ViewChild } from '@angular/core';
import { UntypedFormControl, UntypedFormGroup, Validators } from '@angular/forms';
import { DomSanitizer } from '@angular/platform-browser';
import { ActivatedRoute, Router } from '@angular/router';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { ToastrService } from 'ngx-toastr';
import { ScrollToBottomDirective } from 'src/app/admin/directive/scroll-to-bottom/scroll-to-bottom.directive';
// import { Chat } from 'src/app/admin/services/firebase/chat';
import { FirebaseServiceService } from 'src/app/admin/services/firebase/firebase-service.service';
import { OrderServiceService } from 'src/app/admin/services/orders/order-service.service';
import { UserdataService } from 'src/app/admin/services/shared/userdata/userdata.service';
import * as _ from 'lodash';
import { map } from 'rxjs/operators';
import Swal from 'sweetalert2';

import { Database, onChildAdded, onChildChanged, ref, update } from '@angular/fire/database';
@Component({
    selector: 'app-groupchat-ongoing',
    templateUrl: './groupchat-ongoing.component.html',
    styleUrls: ['./groupchat-ongoing.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: false
})
export class GroupchatOngoingComponent implements OnInit {

  /**
   * Scroll to bottom
   */

  @ViewChild(ScrollToBottomDirective)
  scroll!: ScrollToBottomDirective;

  id: any = ''; dataList: any = ''; chatId: any = ''; chatsRef: any = ''
  chatList: any = [];
  customerId = ''
  initialMsg = ''
  BaseUrl: any;
  isChatComplete: Boolean = false
  private database: Database = inject(Database)

  constructor(
    private route: ActivatedRoute,
    private orderService: OrderServiceService,
    private toast: ToastrService,
    private userdata: UserdataService,
    private firebaseService: FirebaseServiceService,
    private router: Router,
    private modalService: NgbModal,
    private cdref: ChangeDetectorRef,
    private trusturl: DomSanitizer,
    @Inject('BASE_IMAGE_URL') _imageurl: any) {
    this.BaseUrl = _imageurl
  }


  ngAfterContentChecked() {
    this.cdref.detectChanges();
  }

  ngOnInit(): void {
    this.id = this.route.snapshot.paramMap.get('id')
    this.chatId = this.route.snapshot.paramMap.get('id') || '';
    this.getDetailGroupChat()
  }

  getDetailGroupChat() {
    this.orderService.detailGroupChat({ _id: this.id }).subscribe(
      (res: any) => {
        this.dataList = res.data
        this.initialMsg = this.dataList.initial_msg
        this.isChatComplete = this.dataList.is_order_completed
        // this.chatsRef = firebase.database().ref('groupchat/' + this.id);
        this.chatsRef = ref(this.database, 'groupchat/' + this.id);
        this.childAdded()
        this.retrieveAllChats()
        this.childChanged()
        this.chatList = this.dataList.chatinfo;
        console.log(this.chatList);
      }, err => {

        //console.log(err)
        //this.toast.error(err.error.message, 'Error')
      }
    )
  }
  /**
   * Retrieve all Chat from Backend
   */
  retrieveAllChats() {

     this.firebaseService.getGroupChatList(this.chatId).subscribe((chat) => {
      this.chatList = chat;
      this.cdref.detectChanges();  // force Angular to update
      console.log(this.chatList);
      if (this.chatList.length <= 0) {
        this.chatList = this.dataList.chatinfo;
        this.cdref.detectChanges();
      }
    });
  }

  // public childAdded() {
  //   var demo = this
  //   var i = 0
  //   this.chatsRef.on("child_added", function (snapshot: any) {
  //     var data = snapshot.val();
  //     var key = snapshot.key;
  //     if (data.is_read_admin != undefined && !data.is_read_admin) {
  //       demo.chatsRef.child(key).update({ is_read_admin: true });
  //       //console.log(data, i, key)
  //     }
  //     if (key == '- Typing') {
  //       if (data.customer == true) {
  //         demo.customerTyping = true
  //       }
  //       else{
  //         demo.customerTyping = false
  //       }
  //       if (data.astrologer == true) {
  //         //console.log(data.astrologer)
  //         demo.astrologerTyping = true
  //       }else{
  //         demo.astrologerTyping = false
  //       }
  //       //console.log(demo.astrologerTyping)
  //     }
  //     // demo.chatList.push(data)
  //     i++
  //   })
  // }


    childAdded() {
    const astroName = this.dataList.astroId.name;
    const id = this.dataList._id;
    const toast = this.toast;
    const router = this.router;
    const demo = this;
    var i = 0;


    onChildAdded(this.chatsRef, async (snapshot) => {
      const data = snapshot.val();
      const key = snapshot.key;
      // console.log('childAdded', data);

      if (data.is_read_admin != undefined && !data.is_read_admin) {
        demo.chatsRef.child(key).update({ is_read_admin: true });
        //console.log(data, i, key)
      }
      if (key == '- Typing') {
        if (data.customer == true) {
          demo.customerTyping = true
        }
        else{
          demo.customerTyping = false
        }
        if (data.astrologer == true) {
          demo.astrologerTyping = true
        }else{
          demo.astrologerTyping = false
        }
      }
      i++
    });
  }


  /**
   * Child Changed
   */
  customerTyping: boolean = false
  astrologerTyping: boolean = false

  // childChanged() {
  //   var demo = this
  //   this.chatsRef.on("child_changed", function (snapshot: any) {
  //     //console.log(snapshot.key)
  //     var data = snapshot.val();
  //     var key = snapshot.key;
  //     if (key == '- Typing') {
  //       if (data.customer == true) {
  //         demo.customerTyping = true
  //       }
  //       else{
  //         demo.customerTyping = false
  //       }
  //       if (data.astrologer == true) {
  //         //console.log(data.astrologer)
  //         demo.astrologerTyping = true
  //       }else{
  //         demo.astrologerTyping = false
  //       }
  //       //console.log(demo.astrologerTyping)
  //     }
  //   })
  // }

   childChanged() {
    const demo = this;
    const id = this.dataList._id;
    onChildChanged(this.chatsRef, (snapshot) => {
      const data = snapshot.val();
      const key = snapshot.key;

      // Handle typing status
      if (key == '- Typing') {
        if (data.customer == true) {
          demo.customerTyping = true
        }
        else{
          demo.customerTyping = false
        }
        if (data.astrologer == true) {
          //console.log(data.astrologer)
          demo.astrologerTyping = true
        }else{
          demo.astrologerTyping = false
        }
        //console.log(demo.astrologerTyping)
      }
    });
  }

  /**
   * On Input focus show admin typing true
   */





  onKeyUpInput(event: any) {
    //console.log(event)
    const chatId = this.dataList._id; // Replace with your actual chat ID source
    const typingRef = ref(this.database, `chat/${chatId}/- Typing`);
    if(event.target.value.length > 0){
      // this.chatsRef.child('- Typing').update({ admin: true });
      update(typingRef, { admin: true });
    }else{
      update(typingRef,{ admin: false });
    }
  }

  /**
   * On Input Blur show admin typing true
   */
  onBlurInput(event: any) {
    //console.log('blur')
    const chatId = this.dataList._id;
    const typingRef = ref(this.database, `chat/${chatId}/- Typing`);
    update(typingRef, { admin: false });
  }
  /**
   * View Customer Details
   */
  openViewCustomerDetails(content: any) {
    this.modalService.open(content);
  }

  /**
   * Send Chat Message
   */
  isImageUpload = false
  sendMsgForm = new UntypedFormGroup({
    chatId: new UntypedFormControl(''),
    userId: new UntypedFormControl(''),
    message: new UntypedFormControl('', [Validators.required]),
    name: new UntypedFormControl(''),
    is_to_show: new UntypedFormControl(true),
    isImage: new UntypedFormControl(false),
    isFile: new UntypedFormControl(false),
    type: new UntypedFormControl(1), //1-Admin, 2-Astrologer, 3-Customer
  });

  get f() {
    return this.sendMsgForm.controls
  }

  sendMsg() {
    this.sendMsgForm.patchValue({ chatId: this.id })
    this.sendMsgForm.patchValue({ userId: this.userdata.getId() })
    this.sendMsgForm.patchValue({ name: this.userdata.getName() })
    if (!this.isImageUpload) {
      var msg = (this.sendMsgForm.get('message')?.value).trim()
      if (msg != '' && msg != null) {
        var count = (msg.match(/\d/g) || []).length
        var emailsArray = msg.match(/([a-zA-Z0-9._-]+@[a-zA-Z0-9._-]+\.[a-zA-Z0-9._-]+)/gi);
        if (count == 10 || (emailsArray != null && emailsArray.length)) {
          this.sendMsgForm.patchValue({ is_to_show: false })
          //console.log(this.sendMsgForm.get('is_to_show').value, 'if')
        }
        this.sendMsgForm.patchValue({ message: msg })
        const data = new FormData()
        data.append("chatId", this.sendMsgForm.get("chatId")?.value)
        data.append("userId", this.sendMsgForm.get("userId")?.value)
        data.append("message", this.sendMsgForm.get("message")?.value)
        data.append("name", this.sendMsgForm.get("name")?.value)
        data.append("is_to_show", this.sendMsgForm.get("is_to_show")?.value)
        data.append("isImage", this.sendMsgForm.get("isImage")?.value)
        data.append("isFile", this.sendMsgForm.get("isFile")?.value)
        data.append("type", this.sendMsgForm.get("type")?.value)
        //console.log(this.sendMsgForm.get('is_to_show').value, 'after if')
        this.orderService.sendGroupChatMsg(data).subscribe(
          (res: any) => {
            this.sendMsgForm.reset()
            this.sendMsgForm.patchValue({ message: '' })
            this.sendMsgForm.patchValue({ is_to_show: true })
            this.sendMsgForm.patchValue({ isImage: false })
            this.sendMsgForm.patchValue({ isFile: false })
            this.sendMsgForm.patchValue({ type: 1 })
            this.f
            //console.log(this.sendMsgForm.get('is_to_show').value, 'result')
          }, err => {
            this.toast.error(err.error.message, 'Error')
          }
        )
      }
    }
    if (this.isImageUpload) {
      const data = new FormData()
      data.append("chatId", this.sendMsgForm.get("chatId")?.value)
      data.append("userId", this.sendMsgForm.get("userId")?.value)
      data.append("message", this.sendMsgForm.get("message")?.value)
      data.append("name", this.sendMsgForm.get("name")?.value)
      data.append("is_to_show", this.sendMsgForm.get("is_to_show")?.value)
      data.append("isImage", this.sendMsgForm.get("isImage")?.value)
      data.append("isFile", this.sendMsgForm.get("isFile")?.value)
      data.append("type", this.sendMsgForm.get("type")?.value)
      //console.log(this.sendMsgForm.get('is_to_show').value, 'after if')
      this.orderService.sendGroupChatMsg(data).subscribe(
        (res: any) => {
          this.sendMsgForm.reset()
          this.sendMsgForm.patchValue({ message: '' })
          this.sendMsgForm.patchValue({ is_to_show: true })
          this.sendMsgForm.patchValue({ isImage: false })
          this.sendMsgForm.patchValue({ isFile: false })
          this.sendMsgForm.patchValue({ type: 1 })
          this.f
          //console.log(this.sendMsgForm.get('is_to_show').value, 'result')
        }, err => {
          this.toast.error(err.error.message, 'Error')
        }
      )
    }
  }

  checkEnterPressed(event: any) {
    if (event.keyCode === 13) {
      this.sendMsg()
    }
  }

  /**
   * M3- Attachements
   */

  /**
   * Get attachment type
   */
  checkExtenstion(val: any) {
    var fileName, fileExtension;
    fileName = val
    fileExtension = fileName.substr((fileName.lastIndexOf('.') + 1)).toLowerCase();
    if (fileExtension == 'jpg' || fileExtension == 'png' || fileExtension == 'jpeg') {
      return 0
    } else if (fileExtension == 'doc' || fileExtension == 'docx' || fileExtension == 'txt') {
      return 1
    } else if (fileExtension == 'xlsx' || fileExtension == 'xls' || fileExtension == 'csv') {
      return 2
    } else if (fileExtension == 'pdf') {
      return 3
    } else {
      return 4
    }
  }

  public getSanitizeUrl(url: string) {
    return this.trusturl.bypassSecurityTrustUrl(this.BaseUrl + url)
  }

  public getOpenUrl(url: string) {
    //return this.trusturl.bypassSecurityTrustUrl('http://docs.google.com/viewer?url=' + this.BaseUrl + url)
    return this.trusturl.bypassSecurityTrustUrl(this.BaseUrl + url)
  }
  private _albums: any = [];

   open(val: any): void {
    this._albums = [];
    const album = {
      src: this.BaseUrl + val,
    };
    this._albums.push(album);
    const imageUrl = this.BaseUrl + val;
    window.open(imageUrl, '_blank');
    // open lightbox
    // this._lightbox.open(this._albums, 0, { wrapAround: true, showImageNumberLabel: true, fitImageInViewPort: true, centerVertically: true });
  }

  close(): void {
    // close lightbox programmatically
    // this._lightbox.close();
  }

  onFileSelected(evnt: any) {
    // console.log(evnt.target.files[0].type)
    // return
    if (evnt.target.files.length > 0) {
      if (evnt.target.files.length > 0) {
        if (evnt.target.files && evnt.target.files[0]) {
          const allowed_types = ['image/png', 'image/jpeg', 'application/pdf', 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet', 'application/vnd.openxmlformats-officedocument.wordprocessingml.document', 'text/plain', 'text/csv', 'application/doc', 'application/ms-doc', 'application/msword', 'application/excel', 'application/vnd.ms-excel'];
          if (!_.includes(allowed_types, evnt.target.files[0].type)) {
            Swal.fire('Invalid File Extension', 'Only Images,Doc, PDF, Excel are allowed', 'error');
            return;
          } else {
            this.sendMsgForm.patchValue({
              message: evnt.target.files[0]
            })
            this.sendMsgForm.patchValue({
              isImage: true
            })
            if(evnt.target.files[0].type == 'image/png' || 'image/jpeg'){
              this.sendMsgForm.patchValue({
                isFile: false
              })
            }else{
              this.sendMsgForm.patchValue({
                isFile: true
              })
            }
            this.isImageUpload = true
            this.sendMsg()
          }
        }
      }
    }
  }

}
